<template>
    <div class="main-wrapper d-flex justify-center">
        <v-dialog v-model="dialog" width="500" >
            <v-card>
                <v-card-title class="text-h5  lighten-2" style="background: #25ccd5; color:white;">
                Bienvenido de nuevo
                </v-card-title>

                <v-card-text style="padding: 30px 24px 20px;">
                Por favor, completa la información para ver tu resultado de viabilidad y acceder a tu área privada
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
                >
                    Aceptar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <transition :name="animationFade">
            <div v-if="show">
                <v-row class="section_wrapper">
                    <v-col cols=12>
                        <v-form ref="form" lazy-validation class="form_wrapper" v-model="valid">
                            <div v-if="!showIframe" class="d-flex flex-column flex-sm-row align-center justify-center mb-11">
                                <h2 class="mb-0 mr-6">{{productTitle}}</h2>
                                <ChangeProductBlock style="flex:initial"/>
                            </div>
                            <v-row>
                                <v-col cols=12 sm=6>
                                    <v-select 
                                        label="¿Quieres Fijo o Variable?"
                                        outlined
                                        v-model="preScoring.Vivienda.oferta_type"
                                        :items="offerType"
                                        item-text="text"
                                        item-value="value"
                                        dense
                                    />
                                </v-col>
                                <v-col cols=12 sm=6>
                                    <v-select 
                                        label="¿En cuantos años quieres pagar la hipoteca?"
                                        outlined
                                        v-model="preScoring.Vivienda.oferta_years"
                                        :items="years"
                                        item-text="text"
                                        item-value="value"
                                        dense
                                    />
                                </v-col>
                            </v-row>
                            <v-divider class="mb-5"></v-divider>
                            <v-row v-for="(owner,i) in owners" :key="i" class="pt-5">
                                <v-col cols="12 d-flex justify-start"><h2 class="mb-3">Titular {{i+1}}</h2></v-col>
                                <v-col cols=12 sm=6 v-if="i==0">
                                        <v-text-field
                                            label="Nombre completo *"
                                            v-model="owner.nombre_completo"
                                            :rules="[...ruleRequired]"
                                            outlined
                                            color="var(--helloteca-main)"
                                            dense
                                        ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="i==0">
                                    <v-text-field
                                        label="NIF - NIE *"
                                        v-model="owner.nif_nie"
                                        :rules="[...ruleRequired,...ruleCIF]"
                                        outlined
                                        color="var(--helloteca-main)"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="i!=0">
                                        <v-text-field
                                            label="Nombre completo"
                                            v-model="owner.nombre_completo"
                                            outlined
                                            color="var(--helloteca-main)"
                                            dense
                                        ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="i!=0">
                                    <v-text-field
                                        label="NIF - NIE"
                                        v-model="owner.nif_nie"
                                        :rules="[...ruleCIF]"
                                        outlined
                                        color="var(--helloteca-main)"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                
                                <v-col cols=12 sm=6>
                                    <InputCalendar 
                                        :model="owner.nacimiento"
                                        label="Fecha de nacimiento *"
                                        outlined
                                        @setDate="(payload)=>{
                                            SET_OWNER_BIRTHDATE({date:payload,owner:i});
                                        }"
                                        required=true
                                        :max="getBirthdateDateMax()"
                                        :min="getBirthdateDateMin()"
                                        :showInitial="getBirthdateDateMax()"
                                        sourceFormat="AAAA/MM/DD"
                                        dense
                                    ></InputCalendar>
                                </v-col>
                                <v-col cols=12 sm=6>
                                    <v-select 
                                        label="Contrato del Titular *"
                                        outlined
                                        v-model="owner.contrato"
                                        :items="commonVars.contractTypes"
                                        :rules="[...ruleRequired]"
                                        item-text="name"
                                        item-value="code"
                                        dense
                                    />
                                </v-col>
                                <v-col cols=12 sm=6 v-if="nominaVisible(owner.contrato)">
                                    <v-currency-field
                                        :label="nominaLabel(owner.contrato)"
                                        outlined
                                        v-model="owner.nomina"
                                        :rules="[...ruleRequired]"
                                        :min="0"
                                        :max="50000000"
                                        append-icon="mdi-currency-eur"
                                        :hint="nominaHint(owner.contrato)"
                                        persistent-hint
                                        dense
                                    ></v-currency-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="pagasVisible(owner.contrato)">
                                    <v-select 
                                        label="Número de pagas"
                                        outlined
                                        v-model="owner.numero_pagas"
                                        :items="numero_pagas"
                                        item-text="text"
                                        item-value="value"
                                        dense
                                    ></v-select >
                                </v-col>
                                <v-col cols=12 sm=6 v-if="antiguedadVisible(owner.contrato)">
                                    <InputCalendar 
                                        :model="owner.antiguedad"
                                        :label="antiguedadLabel(owner.contrato)"
                                        outlined
                                        @setDate="(payload)=>{
                                            SET_OWNER_JOB_SENIORITY({date:payload, owner:i});
                                        }"
                                        :max="getJobDateMax()"
                                        sourceFormat="AAAA/MM/DD"
                                        required=true
                                        dense
                                    ></InputCalendar>
                                </v-col>
                                <v-col cols=12 sm=6>
                                    <v-currency-field
                                        label="Cuotas mensuales de otras deudas *"
                                        outlined
                                        v-model="owner.gastos"
                                        :rules="[...ruleRequired]"
                                        :min="0"
                                        :max="50000"
                                        append-icon="mdi-currency-eur"
                                        :hint="prestamoHint(i)"
                                        persistent-hint
                                        dense
                                    ></v-currency-field>
                                </v-col>
                                
                                <v-col cols="12" class="d-flex">
                                    <v-btn class="mr-2 elevation-0 add-owner-btn" v-if="i<3" @click="ADD_OWNER" rounded dark color="var(--helloteca-main)"><v-icon small class="mr-2">mdi-account-plus</v-icon> Añadir titular</v-btn>
                                    <v-btn v-if="i>0" @click="DELETE_OWNER(i)" class="elevation-0 add-owner-btn remove" rounded dark color="#CC0000"><v-icon small class="mr-2">mdi-account-minus</v-icon>Eliminar titular</v-btn>
                                </v-col>
                            </v-row>
                            <v-divider class="my-5"></v-divider>
                            <v-row>
                                <v-col  cols="6" class="d-flex flex-column align-start ">
                                        <v-btn @click="$router.push('view2')" depressed class="blue_button error">Atras</v-btn>
                                    </v-col>
                                    <v-col  cols="6" class="d-flex flex-column align-end">
                                        <v-btn @click="send" :loading="loading" depressed class="blue_button">Calcular viabilidad</v-btn>
                                        <p class="steps_info">Paso 2 de 3</p>
                                    </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
            </div>
        </transition>
    </div>
</template>

<script>
    const api = 'https://api7.cloudframework.io/helloteca/score';
    import axios from 'axios';
    
    import { mapState, mapMutations, mapActions } from 'vuex';
    import rulesMixin from '../mixins/rulesMixin';
    import ChangeProductBlock from '../components/ChangeProductBlock';
    import InputCalendar from '../components/InputCalendar';
    import goTo from 'vuetify/es5/services/goto'

    export default {
        mixins: [rulesMixin],
        components:{
            ChangeProductBlock,
            InputCalendar
        },
        data() {
            return {
                valid: false,
                show: false,
                animationFade: 'fadeR',
                dialog:false,
            }
        },
        mounted() {
            this.show = true;
            if(this.$route.query.token_id){
                this.SET_SHOW_IFRAME( this.$route.query.iframe);
               setTimeout(() => this.test_prescoring(), 1000); 
            }else{
                this.test_prescoring()
            }
           
        },
        methods: {
            ...mapMutations([
                'CHANGE_ACTIVE_PRODUCT',
                'SET_ACTIVE_STEP',
                'ADD_OWNER',
                'DELETE_OWNER',
                'SET_OWNER_BIRTHDATE',
                'SET_OWNER_JOB_SENIORITY',
                'SET_PRESCORING_DATA',
                'SET_LOADING',
                'SET_SHOW_IFRAME',
                'SET_PRESCORING_WARNINGS'
            ]),
            ...mapActions([
                'calculateScoring',
            ]),
            callChangeActiveProduct(type){
                this.CHANGE_ACTIVE_PRODUCT(type)
            },
            test_prescoring(){
                 if(this.initalDataLoaded && this.accesibleViews.includes('view3')){
                    setTimeout(() => {
                        this.$refs.form.resetValidation();
                    }, 0);
                    this.animationFade = (this.activeStep > 3) ? 'fadeL' : 'fadeR'
                    this.SET_ACTIVE_STEP(3);
                    goTo(0, {offset:60});
                    if(this.$route.query.modal_welcome=='true'){
                        this.dialog = true;
                    }
                }else{
                    this.$router.push('/view2');
                }
            },
            send(){            
                if(this.$refs.form.validate()){
                    this.SET_LOADING(true);
                    this.calculateScoring()
                        .then(response=>{
                            this.SET_LOADING(false);
                            this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                            this.SET_PRESCORING_WARNINGS(response.data.data.prescoring_warnings);
                            this.SET_ACTIVE_STEP(4);
                            this.$router.push('success');
                        })
                        .catch(e=>{
                            this.SET_LOADING(false);
                            console.log('Error: ' , e);
                        })
                }else{
                    setTimeout(() => {
                        const el = document.querySelector(".v-messages.error--text:first-of-type");
                        goTo(el, {offset:120});
                    }, 200);
                }
            },
            getBirthdateDateMax(){
                let date = new Date();
                return String(date.getFullYear()-18+'-'+String("0" + (date.getMonth() + 1)).slice(-2)+'-'+String("0" + date.getDate()).slice(-2));
            },
            getBirthdateDateMin(){
                let date = new Date();
                return String(date.getFullYear()-70+'-'+String("0" + (date.getMonth() + 1)).slice(-2)+'-'+String("0" + date.getDate()).slice(-2));
            },
            getJobDateMax(){
                let date = new Date();
                return String(date.getFullYear()+'-'+String("0" + (date.getMonth() + 1)).slice(-2)+'-'+String("0" + date.getDate()).slice(-2));
            },
            nominaLabel(contrato){ 
                let label = 'Nómina neta mensual *';
                switch (contrato) {
                    case 'autonomo':
                        label = 'Base Imponible General de la renta *';
                        break;
                    case 'rentista':
                        label = 'Ingresos mensuales netos *';
                        break;
                    case 'pensionista_jubilado':
                        label = 'Pensión neta mensual *';
                        break;
                }
                return label;
                
            },
            nominaHint(contrato){ 
                let label = null;
                switch (contrato) {
                    case 'autonomo':
                        label = '(ingreso neto anual)';
                        break;
                }
                return label;
                
            },
            prestamoHint(owner){ 
                let label = 'Tienes que introducir la suma de las cuotas mensuales de cualquier tipo de préstamo si tienes, como hipoteca/s, préstamos personales, coches, etc.';
                if(owner > 0){
                    label='Introducir sólo aquellas deudas distintas a los titulares anteriores';
                }
                return label;
                
            },
            antiguedadLabel(contrato){ 
                let label = 'Antigüedad del contrato *';
                switch (contrato) {
                    case 'autonomo':
                        label = 'Fecha de alta *';
                        break;
                }
                return label;
                
            },
            nominaVisible(contrato){
                let visible = true;
                switch (contrato) {
                    case 'siningresos':
                    case 'tuslabores':
                    case 'otro':
                        visible = false;
                        break;
                }
                return visible;
            },
            pagasVisible(contrato){
                let visible = true;
                switch (contrato) {
                    case 'autonomo':
                    case 'siningresos':
                    case 'tuslabores':
                    case 'rentista':
                    case 'pensionista_jubilado':
                    case 'otro':
                        visible = false;
                        break;
                }
                return visible;
            },
            antiguedadVisible(contrato){
                let visible = true;
                switch (contrato) {
                    case 'rentista':
                    case 'pensionista_jubilado':
                    case 'siningresos':
                    case 'tuslabores':
                    case 'otro':
                        visible = false;
                        break;
                }
                return visible;
            },
        },
        computed: {
            ...mapState([
                'initalDataLoaded',
                'commonVars',
                'loading',
                'offerType',
                'numero_pagas',
                'years',
                'owners',
                'products',
                'preScoring',
                'token_id',
                'accesibleViews',
                'showIframe'
            ]),
            productTitle(){
                if(this.preScoring && this.preScoring.Vivienda && this.preScoring.Vivienda.tipo_vivienda){
                    let index = this.products.map(product => product.type).indexOf(this.preScoring.Vivienda.tipo_vivienda);
                    return (index >= 0) ? this.products[index].title : '';
                }else{
                    return '';
                }
            },
            
            
        },

    }
</script>

<style lang="scss" scoped>
    .main-wrapper{
        padding: 20px;
        box-sizing: border-box;
    }
    .section_wrapper{
        max-width: 1150px;
        .left-text{
            h2{
                font-weight: 500;
                font-size: 1.6rem;
                line-height: 1.9rem;
                margin-bottom: 20px;
            }
            p{
                font-weight: 500;
                font-size: 1.4rem;
                line-height: 1.6rem;
                span{
                    color: var(--helloteca-main);
                    font-weight: bold;
                }
            }
        }
    }
    .form_wrapper{
        h2{
            font-weight: bold;
            color: var(--helloteca-main);
            font-size: 1.7rem;
            line-height: 1.5rem;
        }
    }
    .steps_info{
        font-size: 0.8rem;
        line-height: .9rem;
        color: #999;
        margin-top: 10px;
    }
    .add-owner-btn{
        text-transform: initial;
        letter-spacing: initial;
        border-radius: 6px;
        font-weight: bold;
        background: #FFF !important;
        color: var(--helloteca-main);
        border: 1px solid var(--helloteca-main) !important;
        transition: all .3s !important;
        &.remove{
            color: #CC0000;
            border: 1px solid #CC0000 !important;
            &:hover{
                transition: all .3s !important;
                background: #CC0000 !important;
                color: #FFF !important;
            }
        }
        &:hover{
            transition: all .3s !important;
            background: var(--helloteca-main) !important;
            color: #FFF !important;
        }
    }
</style>